import { QUERY_KEYS } from "library/shared";
import { IEmployee } from "library/types";
import { useQuery, useQueryClient, UseQueryResult } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

type Props = {
  countryCode: number;
  clientInternalNumberGos: number;
  enabled?: boolean;
};

const getEmployeeData = async ({ countryCode, clientInternalNumberGos }: Props) => {
  const response = await api.get(`/employee/${countryCode}/${clientInternalNumberGos}`);

  return response.data;
};

export function useGetEmployeeData({
  enabled,
  countryCode,
  clientInternalNumberGos,
}: Props): UseQueryResult<IEmployee> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useQuery<IEmployee, Error>(
    [QUERY_KEYS.employeeData, countryCode.toString(), clientInternalNumberGos.toString()],
    () => {
      return getEmployeeData({ countryCode, clientInternalNumberGos });
    },
    {
      enabled: enabled,
      refetchOnMount: false,
      onError: (error: any) => {
        handleAddAxiosErrorNotification(error);
      },
    }
  );
}

export const useInvalidateEmployeeData = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.employeeData,
    });
};
